<!--单条明细-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="max-dialog1256">
    <div ref="print1" style="width: 98%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"  class="print-table">
        <tr class="noborder" v-if="seedcode">
          <td align="right">货品名：</td>
          <td colspan="3">{{seedname}}</td>
          <td align="right" v-if="!isupdate">编&nbsp;&nbsp;&nbsp;&nbsp;码：</td>
          <td v-if="!isupdate">{{seedcode}}</td>
        </tr>
        <tr class="noborder">
          <td align="right">订单号：</td>
          <td>{{controlData.erpserial}}</td>
          <td align="right">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</td>
          <td>{{controlData.adddate}}</td>
          <td align="right">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td v-if="!isupdate">
            {{controlData.cangkuname}}
          </td>
          <td v-if="isupdate" width="140px">
            <el-select v-model="cangkucode" placeholder="请选择" size="mini" @change="changename">
              <el-option
                v-for="item in jxcstoreData"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" width="60">供应商：</td>
          <td width="140">{{controlData.pcustomer||""}}</td>
          <td align="right" width="80">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</td>
          <td width="220">{{controlData.caddress||""}}</td>
          <td align="right" width="60">联系人&nbsp;&nbsp;&nbsp;:</td>
          <td width="140">{{(controlData.clinkman||"")+" " +(controlData.clinkmantel||"")}}</td>
        </tr>
        <!--<tr class="noborder">-->
        <!--<td align="right">收货方：</td>-->
        <!--<td width="140">{{controlData.servedname}}</td>-->
        <!--<td align="right">收货地址：</td>-->
        <!--<td width="220">{{controlData.address||""}}</td>-->
        <!--<td align="right">联系人：</td>-->
        <!--<td width="140">{{(controlData.linkman||"")+" " +(controlData.linkmantel||"")}}</td>-->
        <!--</tr>-->
        <tr class="noborder" v-if="showtitle1 == 'none'">
          <td align="right">供应号：</td>
          <td width="135">
            <el-input v-model="tracknum" size="mini" ref="tracknum" placeholder="请输入供应商单号"
                      onfocus="this.select()"></el-input>
          </td>
          <td align="right">跟踪号：</td>
          <td width="135">
            <el-input v-model="logisticstracknum" size="mini" ref="logisticstracknum" placeholder="请输入跟踪单号"
                      onfocus="this.select()"
            ></el-input>
          </td>
          <td>总数:{{totals}}</td>
          <td>
            <el-button size="mini" v-if="isupdate&&controlData.isdistribute==40" type="success" style="float: right"
                       @click.stop.prevent="showGoodNumSel()">选择
            </el-button>
          </td>
        </tr>
        <tr class="noborder" v-if="controlData.isdistribute==80||controlData.isdistribute==88">
          <td align="right"  width="80">品&nbsp;&nbsp;&nbsp;&nbsp;类：</td>
          <td  width="160">
            <CommonTree ref="treeSeed" :inputSize="'mini'" :defineDataSource="true" @bindData="bindTreeData"
                        :treeWidth="450"
                        :onlyShowGroupType="false" :needTopNode="false" :onlySelectChild="true"
                        :treeHeight="300" :searchText="categoryname"
                        @check="checktree1"></CommonTree>
          </td>
          <td colspan="2">
            <el-button size="mini" type="success" @click.stop.prevent="addGood()">增加</el-button>
            <el-button size="mini" type="success" @click.stop.prevent="showGoodDetailSel()">选择</el-button>
          {{pingpainame}}</td>
        </tr>
        <tr class="noborder" v-if="isshousyjt">
          <td align="right">关联单：</td>
          <td width="140" style="font-weight:bold;cursor:pointer"
              @click="lookDetails()">{{erpserial}}
          </td>
        </tr>
        <tr class="noborder" v-if="showtitle1 == 'none'&&!isupdate&&(filltemplate==10||filltemplate==30)">
          <td align="right"></td>
          <td width="140" style="font-weight:bold;cursor:pointer"><el-switch
            style="display: block" @change="changeTwo()"
            v-model="showallxy"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="全部显示"
            inactive-text="隐藏无数量列">
          </el-switch>
          </td>
        </tr>
        <tr v-show="showerweitable&&controlData.isdistribute!=40&&controlData.isdistribute!=80&&controlData.isdistribute!=88">
          <td colspan="6" style="border:none">
            <TwoDimensionalTable ref="referweibiao" :readonly="isreadonly" :needSetHeight="false" :needSetDisabled="false" :erweitable="erweitable"></TwoDimensionalTable>
          </td>
        </tr>
        <tr v-show="showzuoyoutable&&controlData.isdistribute!=40&&controlData.isdistribute!=80&&controlData.isdistribute!=88">
          <td colspan="6" style="border:none">
            <el-col :span="2" style="text-align: right">右眼：</el-col>
            <el-col :span="6">
              <TwoDimensionalTable ref="referweibiaoright" :readonly="isreadonly" :needSetHeight="false"
                                   :needSetDisabled="false" :erweitable="erweitableright"></TwoDimensionalTable>
            </el-col>
            <el-col :span="2" style="text-align: right">左眼：</el-col>
            <el-col :span="6">
              <TwoDimensionalTable ref="referweibiaoleft" :readonly="isreadonly" :needSetHeight="false"
                                   :needSetDisabled="false" :erweitable="erweitableleft"></TwoDimensionalTable>
              <CstagreementEdit ref="DataContactEdit"></CstagreementEdit>
            </el-col>
          </td>
        </tr>
        <tr v-show="controlData.isdistribute==40">
          <td colspan="6" style="border:none">
            <el-table
              :data="seedcodeData"
              :height="tableHeight(300)"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                type="index"
                :index="indexMethod"
                align="center"
                label="序号"
                width="50">
              </el-table-column>
              <el-table-column
                prop="seedcode"
                label="编码"
                align="center"
                width="100"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="seedname"
                label="名称"
                align="center"
                :show-overflow-tooltip="true"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="数量"
                align="center"
                width="80"
                header-align="center">
                <template slot-scope="scope">
                  <el-input style="width: 100%" size="small" v-model="scope.row.totalnumber" @change="totalNumber"
                            :ref='scope.row.id'
                            onfocus="this.select()"
                            @keyup.enter.native="validateCounts(scope.row,scope.$index, $event)"
                            @keyup.down.native="validateCounts(scope.row,scope.$index, $event)"
                            @keyup.up.native="validateCounts(scope.row,scope.$index, $event)"
                            :disabled="isupdate?false:true">>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="formproperty"
                label="属性"
                align="center"
                width="130"
                v-if="!isupdate"
                header-align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.formproperty?scope.row.formproperty.substring(2,(scope.row.formproperty.length-3)):''}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="130" v-if="isupdate">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger"
                             @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </td>
        </tr>
        <tr v-show="controlData.isdistribute==80||controlData.isdistribute==88">
          <td colspan="6" style="border:none">
            <el-table
              :data="seedcodeData"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                type="index"
                :index="indexMethod"
                align="center"
                label="序号"
                width="50">
              </el-table-column>
              <el-table-column
                prop="seedcode"
                label="编码"
                align="center"
                width="100"
                :show-overflow-tooltip="true"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="seedname"
                label="名称"
                :show-overflow-tooltip="true"
                align="left"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="model"
                label="型号"
                width="100"
                align="center"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="color"
                label="色号"
                width="100"
                align="center"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="数量"
                align="center"
                width="90"
                header-align="center">
                <template slot-scope="scope">
                  <el-input style="width: 100%" size="small" v-model="scope.row.totalnumber"
                            :ref='scope.row.id'
                            onfocus="this.select()"
                            @keyup.enter.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @keyup.down.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @keyup.up.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @change="totalNumber"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="130">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger"
                             @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" style="padding-top:5px;">说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="5" style="border: none;height: 30px;padding-top:5px;">
            <div v-html="getLiuYan(controlData.remark)">
            </div>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="2">&nbsp;&nbsp;&nbsp;检查人员：</td>
          <td colspan="2">入库人员：</td>
          <td colspan="2">采购人员：{{controlData.uname}}</td>
        </tr>
      </table>
      <StorageBadOut ref="StorageBadOut"></StorageBadOut>
      <BaoSunDetail ref="BaoSunDetail"></BaoSunDetail>
      <BatchBuyFormProperties ref="batchBuyFormProperties" @afterSelectCode="afterSelectFrame"></BatchBuyFormProperties>
      <MakeInventoryFrameAdd ref="MakeInventoryFrameAdd" @afterSelect="afterAddFrame"></MakeInventoryFrameAdd>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button type="primary" v-if="isupdate" @click="update">保存</el-button>
      <el-button type="primary" @click="print1" v-if="!isupdate">打印</el-button>
      <el-button type="primary" @click="exportExceltable" size="mini">导出</el-button>
    </div>
  </el-dialog>
</template>


<script>
  import {getPrice} from '@/api/set/goodsprice';
  import {printingbuy, jxcstorelist, buyodersavedetail, buysaveFramedetail} from '@/api/set/csagreement';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import {getRemark} from '@/plugin/ordercommon'
  import {getListData} from '@/api/set/jxcstore'
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import StorageBadOut from '@/components/warehouse/StorageBadOut'
  import BaoSunDetail from '@/components/testorder/cstagreement/BaoSunDetail';
  import BatchBuyFormProperties from '../buyagreement/BatchBuyFormProperties';
  import {getListfixcilumn,listgoodsframe, getDetail, getGoodsTree} from '@/api/set/jxcgooddetail'
  import MakeInventoryFrameAdd from '../../warehouse/MakeInventoryFrameAdd';

  export default {
    name: 'BuyOrderEditSeedDetail',
    data() {
      return {
        formLabelWidth: '120px',
        dialogSeeVisible: false,
        loading: true,
        seedcode: "",
        seedname: '',
        tableData: [],
        column: [],
        categorycode:'',
        categoryname:'',
        pingpainame:'',
        seedgoodsFrame:[],
        controlData: {},
        erweitable: [],
        erweitableleft: [],
        erweitableright: [],
        cangkucode: '',
        cangkuname: '',
        showallxy:false,
        costpricebook: {},
        BookContent: [],
        BookContentLeft: [],
        BookContentRight: [],
        showtitle1: 'none',
        isbuyorder: '',
        isupdatechange: false,
        isupdate: false,
        isreadonly: true,
        jxcstoreData: [],
        filltemplate: "",
        showzuoyoutable: false,
        showerweitable: false,
        totalnumber: 0,
        syht: [],
        isshousyjt: false,
        erpserial: '',
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        seedcodeData: [],//手动批量采购数量选择商品
        oldseedcodeData: [],
        totals: 0,
        isshowconfirm: ''//控制父类页面确认入库按钮显示
      }
    },
    methods: {
      exportExceltable() {
        this.$refs.referweibiao.getExcel(this.controlData.erpserial  + this.seedname);
      },
      changeTwo(){
        localStorage.setItem("twodimensional_showallxy",this.showallxy);
        this.initBookBytype();
      },
      //商品树
      bindTreeData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({onlyShowGroupType:true,categorystarts:'002;003;004;006'})
        })
      },
      checktree1(guids, names, arr) {
        this.seedgoodsFrame = []
        this.categorycode = guids
        this.categoryname = names
        this.pingpainame=guids.length==12?(this.$refs.treeSeed.getNode(guids.substr(0, guids.length - 3)).label):'';

        if (this.categoryname == "") {
          this.$message({
            message: '请选择品类',
            type: 'error'
          })
          return
        }
        listgoodsframe({
          categorycode: this.categorycode,
          filltemplate: '80',
        }).then(response => {
          this.seedgoodsFrame = response.data.obj
          if (this.seedgoodsFrame.length > 0) {
            for (let i in this.seedgoodsFrame) {
              this.seedgoodsFrame[i].totalnumber = 0
            }
          } else {
            return
          }

        }).catch((error) => {
          console.log(error)
        });

      },
      addGood(){
        if(this.seedgoodsFrame.length==0){
          this.$message.error("品牌下没有商品");
          return
        }
        this.$refs.MakeInventoryFrameAdd.show(this.seedgoodsFrame,{cangkucode:this.cangkucode,cangkuname:this.cangkuname})
      },
      //显示商品选择页面
      showGoodDetailSel() {
        if (this.seedgoodsFrame.length == 0) {
          this.$message.error("品牌下没有商品");
          return
        }
        for (let i in this.seedgoodsFrame) {
          this.seedgoodsFrame[i].totalnumber = 0
        }
        //参数  true 显示库存，seedcode分类，cangkucode 仓库，seedcodeData 分类下的商品
        this.$refs.batchBuyFormProperties.initData(true, this.categorycode, this.controlData.cangkucode, this.seedgoodsFrame, this.controlData.pcustomerserial)
      },
      //显示数量商品选择页面
      showGoodNumSel() {
        var categorycode = this.controlData.seedinfo.split(',')[0].substr(1)
        this.$refs.batchBuyFormProperties.initData(true, categorycode, this.cangkucode, this.oldseedcodeData, this.controlData.pcustomerserial)
      },
      //选择商品之后执行
      afterSelectNumCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.seedcodeData) {
            //判读该商品是否属于
            if (this.seedcodeData[j].seedcode == arr[i].seedcode) {
              biaoji = 1
              count++;
              this.seedcodeData[j].totalnumber += arr[i].totalnumber;//更新数量
              break
            }
          }
          if (biaoji == 0) {
            this.seedcodeData.push({
              categoryname: arr[i].lname,
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              categorycode: arr[i].categorycode,
              totalnumber: arr[i].totalnumber,
              formproperty:'[{}]',
            })
          }
        }
        this.totalNumber()
      },
      afterAddFrame(arr){
        var arrAdd=[]
        for (var i in arr) {
          arrAdd.push({
            seedcode: arr[i].seedcode,
            seedname: arr[i].seedname,
            color:arr[i].C,
            model:arr[i].M,
            categorycode: '',
            totalnumber: arr[i].P,
          });
        }
        this.afterSelectFrame(arrAdd);
      },
      //选择商品之后执行
      afterSelectFrame(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.seedcodeData) {
            //判读该商品是否属于
            if (this.seedcodeData[j].seedcode == arr[i].seedcode && this.seedcodeData[j].model == arr[i].model && this.seedcodeData[j].color == arr[i].color) {
              biaoji = 1
              this.seedcodeData[j].totalnumber += arr[i].totalnumber;//更新数量
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.seedcodeData.push({
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              color:arr[i].color,
              model:arr[i].model,
              categorycode: arr[i].categorycode,
              totalnumber: arr[i].totalnumber,
              formproperty: '[{}]',
              packagesize:'{"M":"'+arr[i].model+'","C":"'+arr[i].color+'"}',
              onlycode:'',
              barcodes:[]
            })
          }
        }  //从小到大排序
        this.seedcodeData.sort(function (a, b){
          if (a.model == b.model)
            return a.color.localeCompare(b.color);
          else
            return a.model.localeCompare(b.model);
        });
        this.totalNumber();
      },
      //回车跳入下一行
      validateCounts(row, index, e) {
        var keyCode = e.keyCode || e.which || e.charCode;
        if (keyCode == 40 || keyCode === 13) {//回车，下方向键
          this.$refs[row.id].blur()
          if (this.seedcodeData.length - 1 === index) {
            index = -1
          }
          this.$refs[Object.keys(this.$refs)[index + 1]].focus();
        } else if (keyCode == 38) {//上方向键
          this.$refs[row.id].blur()
          if (index === 0) {
            index = this.seedcodeData.length
          }
          this.$refs[Object.keys(this.$refs)[index - 1]].focus();
        }
      },
      //给tableData 添加 id，共回车使用
      indexMethod(index) {
        this.seedcodeData[index].id = index
        return index + 1;
      },
      //购买总数
      totalNumber() {
        this.totals = 0
        for (let i in this.seedcodeData) {
          this.totals = this.totals + parseInt(this.seedcodeData[i].totalnumber)
        }
      },
      getTitle() {
        let result = "";
        let temp = localStorage.getItem("hpapi_userInfoModel")
        if (temp) {
          result += JSON.parse(temp).tenantname || ""
        }
        result += "采购订单"
        return result
      },
      showDetail(item) {

      },
      //删除明细
      handleDelete(index, row) {
        this.seedcodeData.splice(index, 1)
        //总数计算
        this.totalNumber()
      },
      print1() {
        // window.print()
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.showtitle1 = "none"
        })
      },
      show() {
        this.dialogSeeVisible = true;
      },
      changename(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.cangkuname = this.jxcstoreData[i].cangkuname;
            this.controlData.cangkucode=val;
            this.controlData.cangkuname=this.cangkuname;
          }
        }
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      //isshowqr  这个是控制父类页面 确认入库按钮显示隐藏
      initData(unitguid, seedcode, seedname, isupdate, filltemplate, tabledata, isshowqr) {
        this.initForm()
        this.filltemplate = filltemplate
        if (isshowqr)
          this.isshowconfirm = 1
        else
          this.isshowconfirm = ''
        this.seedcode = seedcode
        if (isupdate && isupdate == 1) {
          this.isupdate = true
          this.isreadonly = false
        } else {
          this.isupdate = false
          this.isreadonly = true
        }


        printingbuy(
          {
            ugg: JSON.stringify({
              unitguid: unitguid,
              isbuyorder: 1,
              seedcode: this.seedcode,
              filltemplate: this.filltemplate
            })
          }).then(response => {
          this.controlData = response.data.obj.detail;
          //手动批量采购用到
          if (this.controlData.isdistribute == 40) {
            this.seedcodeData = JSON.parse(JSON.stringify(response.data.obj.formdetail))
            if (this.seedcodeData.length > 0) {
              this.totalNumber()
            }
            if (this.isupdate) {
              var seedinfos = response.data.obj.detail.seedinfo.split(',')
              if (seedinfos.length > 0) {
                getListfixcilumn({
                  categorycode: seedinfos[0].substr(1),
                  nostock: 1,
                }).then(response => {
                  var obj = response.data.obj.rows
                  var seedcodes = []
                  if (obj.length > 0) {
                    for (let i in obj) {
                      if (obj[i].filltemplate == 40) {
                        seedcodes.push(obj[i].seedcode)
                        obj[i].totalnumber = 0
                        this.oldseedcodeData.push(obj[i])
                      }
                    }
                  }
                }).catch((error) => {
                  console.log(error)
                });
              }
            }
          }else if (this.controlData.isdistribute == 80||this.controlData.isdistribute == 88) {
            this.seedcodeData = [];
            for (let i in this.controlData.billmap) {
              var row = this.controlData.billmap[i];
              if (row["产品名称"] == '合计')
                continue;

              var pg = row.packagesize;
              var model = ''
              var color = ''
              if (pg) {
                model = JSON.parse(pg).M;
                color = JSON.parse(pg).C;
              }
              this.seedcodeData.push({
                seedcode: row.seedcode,
                packagesize: row.packagesize,
                seedname: row["产品名称"],
                model: model,
                color: color,
                totalnumber: row["数量"]
              })
            }
            if (this.seedcodeData.length > 0) {
              this.totalNumber()
            }
          }

          this.BookContent = response.data.obj.goodsDetail;
          this.seedname = response.data.obj.seedname;
          this.tracknum = this.controlData.tracknum;
          this.logisticstracknum = this.controlData.logisticstracknum
          if (response.data.obj.erpserial) {
            this.erpserial = response.data.obj.erpserial;
            this.isshousyjt = true
          } else {
            this.isshousyjt = false
          }
          this.BookContent.forEach(o => {
            this.totalnumber = this.totalnumber + o.P;
          })
          if (!filltemplate)
            this.filltemplate = response.data.obj.filltemplate
          //判断是否有成本价
          if (!this.isupdate) {
            if (this.filltemplate == "30") {//区分左右眼
              this.showzuoyoutable = true
              this.BookContent.forEach(o => {
                if (o.type == "L")
                  this.BookContentLeft.push(o)
                else
                  this.BookContentRight.push(o)
              })
            } else {
              this.showerweitable = true
            }
            this.initBookBytype();
          } else {//修改
            if (this.filltemplate == "30") {//区分左右眼
              this.showzuoyoutable = true
              this.BookContent.forEach(o => {
                if (o.type == "L")
                  this.BookContentLeft.push(o)
                else
                  this.BookContentRight.push(o)
              })
            }else
              this.showerweitable = true

            this.getXYRange()
            getListData().then(response => {
              this.jxcstoreData = response.data.obj.rows
              this.cangkucode = this.controlData.cangkucode
              this.cangkuname = this.controlData.cangkuname
            })
          }
        });

      },
      initBookBytype(){
        if(this.showallxy) {
          if (!this.seedcode) return;
          getPrice({
            seedcode: this.seedcode,
            filterType: 'cost'
          }).then((response) => {
            if (response.data.code == 0 && response.data.obj) {
              this.costpricebook = response.data.obj
              if (this.filltemplate == "30") {
                this.$refs.referweibiaoleft.initBook(this.costpricebook, this.BookContentLeft)
                this.$refs.referweibiaoright.initBook(this.costpricebook, this.BookContentRight)
                this.$refs.referweibiaoright.initBookFullFix();
                this.$refs.referweibiaoleft.initBookFullFix();
              } else {
                this.$refs.referweibiao.initBook(this.costpricebook, this.BookContent)
                this.$refs.referweibiao.initBookFullFix();
              }
            }
          })
        }else {
          if (this.filltemplate == "30") {
            this.$refs.referweibiaoleft.initBookFix(this.BookContentLeft)
            this.$refs.referweibiaoright.initBookFix(this.BookContentRight)
          } else {
            this.$refs.referweibiao.initBookFix(this.BookContent);
          }
        }
      },
      lookDetails() {
        switch (this.erpserial.substring(0, 2)) {
          case "78":
            this.$refs.BaoSunDetail.show(this.erpserial);
            break;
          case "79":
            this.$refs.StorageBadOut.show(this.erpserial);
            break;
          default:
            let row = {
              erpserial: this.erpserial
            }
            this.$refs.DataContactEdit.initData(row)
            this.$refs.DataContactEdit.show()
            break;
        }
      },

      update() {
        //取出对应的表单详情和数量
        var arr = [];
        var seedcodelist = '';
        if (this.controlData.isdistribute == 40 || this.controlData.isdistribute == 80|| this.controlData.isdistribute == 88) {
          for (let i in this.seedcodeData) {
            if (this.seedcodeData[i].totalnumber != 0) {
              this.seedcodeData[i].P = this.seedcodeData[i].totalnumber
              arr.push(this.seedcodeData[i])
              seedcodelist += this.seedcodeData[i].seedcode + ';';
            }
          }
        } else {
          if (this.filltemplate == "30") {//左右眼
            for (let i in   this.erweitableleft) {
              let temp = this.erweitableleft[i].filter((t) => {
                t.type = "L"
                return typeof(t.P) != "undefined" && t.P !== "";
              })
              arr = arr.concat(temp)
            }
            for (let i in   this.erweitableright) {
              let temp = this.erweitableright[i].filter((t) => {
                t.type = "R"
                return typeof(t.P) != "undefined" && t.P !== "";
              })
              arr = arr.concat(temp)
            }
          } else {//非左右眼
            for (let i in   this.erweitable) {
              let temp = this.erweitable[i].filter((t) => {
                return typeof(t.P) != "undefined" && t.P !== "";
              })
              arr = arr.concat(temp)
            }
          }
        }
        if (arr.length == 0) {
          this.$message({
            message: '输入数量',
            type: 'warning'
          })
          return
        }
        if (!this.cangkucode) {
          this.$message({
            message: '请选择仓库',
            type: 'warning'
          })
          return
        }
        if (JSON.parse(localStorage.getItem("hpapi_parames")).other.oddrequired == 'true') {
          if (!this.logisticstracknum) {
            this.$message({
              message: '请输入跟踪单号',
              type: 'error'
            })
            return
          }
        }
        var mapParam = {
          pcustomerserial: this.controlData.pcustomerserial,
          pcustomer: this.controlData.pcustomer,
          cangkuname: this.cangkuname,
          cangkucode: this.cangkucode,
          address: this.controlData.address,
          linkman: this.controlData.linkman,
          linkmantel: this.controlData.linkmantel,
          isupdate: '1',
          unitguid: this.controlData.unitguid,
          remark: this.remark,
          tracknum: this.tracknum.trim(),
          logisticstracknum: this.logisticstracknum.trim(),
          isgift: (this.controlData.isfile && this.controlData.isfile == 1) ? 1 : -1,
        };
        if (this.controlData.isdistribute == 40 || this.controlData.isdistribute == 80|| this.controlData.isdistribute == 88) {
          mapParam.seedcodelist = seedcodelist;
        } else {
          mapParam.seedcode = this.seedcode;
          mapParam.seedname = this.seedname;
        }

        buyodersavedetail({
          jxcforms: JSON.stringify(arr),
          map: JSON.stringify(mapParam)
        }).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            let row = {
              unitguid: this.controlData.unitguid
            }
            let isupdatechange = true
            this.$emit('bindGrid', row, 1, this.isshowconfirm, "", isupdatechange);
            this.dialogSeeVisible = false;
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }

          //刷新列表
        });
      },

      //
      // getXYRange() {
      //   getPrice({seedcode: this.seedcode}).then((response) => {
      //     if (response.data.code == 0 && response.data.obj) {
      //       this.costpricebook = response.data.obj
      //     } else {
      //       this.costpricebook = {}
      //     }
      //     this.$refs.referweibiao.initBook(this.costpricebook, this.BookContent)
      //   })
      //
      // },

      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.cangkucode = ""
        this.cangkuname = ""
        this.categorycode=""
        this.categoryname=""
        this.seedgoodsFrame=[]
        this.pingpainame=''
        this.BookContent = []
        this.BookContentLeft = []
        this.BookContentRight = []
        this.column = []
        this.seedcode = ''
        this.tableData = []
        this.isupdatechange = false
        this.showzuoyoutable = false
        this.showerweitable = false
        this.filltemplate = ""
        this.totalnumber = 0
        this.isshowconfirm = ''
        this.seedcodeData = []
        this.oldseedcodeData = []
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
      },

      getXYRange() {
        if(!this.seedcode) return;
        getPrice({
          seedcode: this.seedcode,
          filterType: 'cost'
        }).then((response) => {
          if (response.data.code == 0 && response.data.obj) {
            this.costpricebook = response.data.obj
          } else {
            this.costpricebook = {}
          }
          this.createPriceBook()
        })
      },

      createPriceBook() {
        if (this.filltemplate == "30") {
          this.$refs.referweibiaoleft.initBook(this.costpricebook, this.BookContentLeft)
          this.$refs.referweibiaoright.initBook(this.costpricebook, this.BookContentRight)
        } else
          this.$refs.referweibiao.initBook(this.costpricebook, this.BookContent)
      },

    },
    mounted() {
      this.showallxy=localStorage.getItem("twodimensional_showallxy");
    },
    components: {
      TwoDimensionalTable,
      CstagreementEdit,
      BaoSunDetail,
      StorageBadOut,
      BatchBuyFormProperties,
      MakeInventoryFrameAdd
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>




// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BuyOrderEditSeedDetail.vue